import { resolveImagePath } from '@/utils/imageResolver.ts';

interface Product {
  id: string;
  name: string;
  price: string;
  image: string;
  sale?: boolean;
  freeShipping?: boolean;
  moreOptions?: boolean;
  href: string;
}

const products: Product[] = [
  {
    id: "1",
    name: "42B cap",
    price: "$30.00",
    image: "/merchandise/42b-cap.jpg",
    href: "/ols/products/42b-cap"
  },
  {
    id: "2", 
    name: "logo hat",
    price: "$30.00",
    image: "/merchandise/logo-cap.jpg",
    href: "/ols/products/logo-hat"
  },
  {
    id: "3",
    name: "42B t shirt men's", 
    price: "$30.00",
    image: "/merchandise/42b-mens-t.jpg",
    href: "/ols/products/42b-t-shirt-mens",
    sale: true,
    freeShipping: true,
    moreOptions: true
  },
  {
    id: "4",
    name: "Logo t-shirt men's",
    price: "$30.00", 
    image: "/merchandise/logo-mens-t.jpg",
    href: "/ols/products/logo-t-shirt-mens",
    freeShipping: true,
    moreOptions: true
  },
  {
    id: "5",
    name: "42B t-shirt women",
    price: "$30.00",
    image: "/merchandise/42b-womens-t.jpg", 
    href: "/ols/products/42b-t-shirt-women",
    moreOptions: true
  },
  {
    id: "6",
    name: "logo t-shirt women's",
    price: "$30.00",
    image: "/merchandise/logo-womens-t.jpg",
    href: "/ols/products/logo-t-shirt-womens", 
    sale: true,
    freeShipping: true,
    moreOptions: true
  }
];

export function Merchandise() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-8">
          <div className="flex justify-between items-center mb-4">
            <div className="text-sm text-gray-600">
              <span>Most popular</span>
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">All Products</h2>
          <div className="mt-2">
            <a href="/merchandise" className="text-blue-600 hover:text-blue-800 text-sm">
              View more →
            </a>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div key={product.id} className="group">
              <a href={product.href} className="block">
                <div className="relative bg-gray-50 rounded-lg overflow-hidden aspect-square">
                  {/* Product Image */}
                  <img
                    src={resolveImagePath(product.image)}
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                  
                  {/* Sale Badge */}
                  {product.sale && (
                    <div className="absolute top-2 left-2 bg-red-600 text-white px-2 py-1 text-xs font-semibold rounded">
                      Sale
                    </div>
                  )}
                </div>
                
                {/* Product Info */}
                <div className="mt-4 space-y-2">
                  {product.freeShipping && (
                    <p className="text-green-600 text-xs font-semibold">Free Shipping</p>
                  )}
                  
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-blue-600">
                    {product.name}
                  </h3>
                  
                  <div className="flex items-center space-x-2">
                    <span className="text-lg font-bold text-gray-900">
                      {product.price}
                    </span>
                    {product.sale && (
                      <span className="text-sm text-gray-500 line-through">
                        {product.price}
                      </span>
                    )}
                  </div>
                  
                  {product.moreOptions && (
                    <p className="text-sm text-gray-500">More options</p>
                  )}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}